import { createContext } from "react";

const toastContext = createContext();

export default toastContext;